import React, { useContext } from 'react';
import classnames from 'classnames';
import PollAnswers from '../../../PollView/PollAnswers';
import SubmissionDetails, { SubmissionDetailsV2, } from '../../../SubmissionDetails';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import { MobileContext } from '../../../Context';
import s from './Poll.scss';
export var PollDetails = function (_a) {
    var onVote = _a.onVote, canVote = _a.canVote, _b = _a.deviation, poll = _b.poll, extended = _b.extended, deviation = _a.deviation;
    var isUplifted = useFlag('actionbar_phase_1');
    var isMobile = useContext(MobileContext);
    if (!poll) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        isUplifted && !isMobile ? (React.createElement(SubmissionDetailsV2, { deviation: deviation })) : (React.createElement(SubmissionDetails, { author: poll.user, className: classnames(s['author-block'], s['details']), isLoaded: !!extended })),
        isMobile && (React.createElement(PollAnswers, { poll: poll, canVote: canVote, onVote: onVote }))));
};
PollDetails.displayName = 'PollDetails';
export default PollDetails;
//# sourceMappingURL=Poll.js.map